import { getMediaSnapshot } from "./input-action.js";
import { isSliderFocused } from "./slider/focus.js";
//#region src/dom/ui/status-announcer.ts
function subscribeToStatusAnnouncer(store, core) {
	let active = true;
	let pending = false;
	let target = store.target;
	let revision = 0;
	const baseline = () => {
		target = store.target;
		pending = true;
		const current = ++revision;
		core.resetSnapshot();
		queueMicrotask(() => {
			if (!active || current !== revision) return;
			pending = false;
			target = store.target;
			if (target) core.processSnapshot(getMediaSnapshot(store));
		});
	};
	const unsubscribe = store.subscribe(() => {
		const nextTarget = store.target;
		if (nextTarget !== target) {
			baseline();
			return;
		}
		if (!nextTarget || pending) return;
		core.processSnapshot(getMediaSnapshot(store));
	});
	baseline();
	return () => {
		active = false;
		unsubscribe();
	};
}
function shouldAnnounceStatusChange(container) {
	return !container || !isSliderFocused(container);
}
//#endregion
export { shouldAnnounceStatusChange, subscribeToStatusAnnouncer };

//# sourceMappingURL=status-announcer.js.map